import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { LocationComponent } from './location/location.component';
import { StudentTransportOptReportComponent } from './student-transport-opt-report/student-transport-opt-report.component';
import { StudentVehicleWiseComponent } from './student-vehicle-wise/student-vehicle-wise.component';
import { VehicleDetailsComponent } from './vehicle-details/vehicle-details.component';
import { RouteDetailsComponent } from './route-details/route-details.component';
import { RouteFeeStructureComponent } from './route-fee-structure/route-fee-structure.component';
import { PrintStudentTransportOptReportComponent } from './print-student-transport-opt-report/print-student-transport-opt-report.component';
import { PrintStudentVehicleWiseComponent } from './print-student-vehicle-wise/print-student-vehicle-wise.component';
import { TransportPaymentComponent } from './transport-payment/transport-payment.component';


const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      { path: 'location', component: LocationComponent, pathMatch: 'full' },
      { path: 'studenttransportoptreport', component: StudentTransportOptReportComponent, pathMatch: 'full' },
      { path: 'studentvehiclewise', component: StudentVehicleWiseComponent, pathMatch: 'full' },
      { path: 'vehicledetails', component: VehicleDetailsComponent, pathMatch: 'full' },
      { path: 'routedetails', component: RouteDetailsComponent, pathMatch: 'full' },
      { path: 'routefeestructure', component: RouteFeeStructureComponent , pathMatch: 'full' },
      { path: 'transportpayment', component: TransportPaymentComponent , pathMatch: 'full' },

    ]
  },
  {
    path: '',
    
    children: [
      { path: 'printstudenttransportoptreport', component: PrintStudentTransportOptReportComponent, pathMatch: 'full' },
      { path: 'printstudentvehiclewise', component: PrintStudentVehicleWiseComponent, pathMatch: 'full' },
    

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransportRoutingModule { }
